// Centralized role-hierarchy helpers, mirroring server/utils/roles.js.
// Roles form a strict hierarchy: "user" < "admin" < "superadmin".
// A superadmin is a SUPERSET of admin. These checks are UX-only — the real
// authorization boundary is the server, which reads the role from the
// DB-backed session, not from anything in the browser.

// True if the user is an admin OR a superadmin (admin-or-above).
export const isAdmin = (user) =>
  !!user && (user.role === "admin" || user.role === "superadmin");

// True only for the top-tier owner account.
export const isSuperAdmin = (user) => !!user && user.role === "superadmin";
